import { useEffect, useState } from "react";
import FormModal from "../../widgets/FormModal";
import { Link } from "react-router-dom";
import Header from "../../widgets/Header";
import Footer from "../../widgets/Footer";

function GeneticRisk() {

  const [show, setShow] = useState(false);
  const openIframeWindow = () => {
    setShow(!show);
  }

  return (
    <>
      <section className="light_bg">
        <Header />
        <div className="top_space"></div>
        <section className="ps">
          <div className="container">
            <h1 className="hadding">
              Genetic Risk Study: Depression, Diabetes, and Obesity in the
              Indian Population
            </h1>
            <div className="position-relative  mt-4 mb-4">
              <img
                src="/assets/img/research/genetic-risk.webp"
                alt="research"
                className="w100 br20"
              />
            </div>
            <h3 className="op0_8"> Overview</h3>
            <p>
              This genetic research, based on EPLIMO’s Indian genetic data,
              reveals how interconnected our genes are when it comes to mental
              health, metabolism, and weight management.
            </p>
            <p>
              The study analyzed hundreds of genetic reports and uncovered
              strong links between magnesium deficiency, depression, obesity,
              and diabetes, highlighting the need for personalized,
              genetic-based wellness approaches.
            </p>
            <h3 className="op0_8">
              Study 1: The Genetic Link Between Magnesium Deficiency,
              Depression, and Poor Antidepressant Response
            </h3>
            <p>Sample Size: 500 genetic reports analyzed for depression risk</p>
            Key Findings:
            <ul className="mb-4 dot_list">
              <li>
                388 individuals had genes linked to poor antidepressant response
                and a higher risk of sexual dysfunction.
              </li>
              <li>217 of these also had genes associated with low stress
                resilience.
              </li>
              <li>
                The majority of those with low stress resilience were also
                genetically predisposed to magnesium deficiency.
              </li>
            </ul>
            Interpretation:
            <p>
              This study identifies a shared genetic pathway between low stress
              resilience, magnesium deficiency, and depression. Individuals with
              these genetic traits may experience poor response to conventional
              antidepressants, suggesting that magnesium optimization and
              genetically based interventions could significantly enhance mental
              health outcomes. These results underscore the importance of
              personalized genetic profiling in understanding and managing
              depression, rather than relying solely on one-size-fits-all
              treatments.
            </p>
            <h3 className="op0_8">
              {" "}
              Study 2: Genetic Predisposition to Fat Retention and Adiponectin
              Deficiency in Obesity Risk
            </h3>
            <p>Sample Size: 450 genetic reports analyzed for obesity risk </p>
            Key Findings:
            <ul className="mb-4 dot_list">
              <li>
                191 individuals had genes associated with impaired fat
                metabolism and higher fat retention.
              </li>
              <li>
                126 of these also carried gene variants linked to low
                adiponectin levels, a crucial hormone responsible for fat
                burning and metabolic balance.
              </li>
            </ul>
            Interpretation:
            <p>
              This study highlights how genetic variants affecting adiponectin
              production can directly increase fat storage and make weight loss
              more difficult. The results emphasize that obesity isn’t only a
              result of diet or lifestyle choices; genetic factors play a major
              role. Personalized nutrition and targeted interventions guided by
              EPLIMO can help address these genetic barriers to effective weight
              management.
            </p>
            <h3 className="op0_8">
              Study 3: Magnesium Deficiency Gene Variant Found in 95% of
              Diabetes Risk Cases
            </h3>
            <p>Sample Size: 500 genetic reports analyzed for diabetes risk</p>
            Key Findings:
            <ul className="mb-4 dot_list">
              <li>
                476 individuals (95%) carried gene variants linked to magnesium
                deficiency, a critical factor influencing glucose metabolism and
                insulin sensitivity.
              </li>
            </ul>
            Interpretation:
            <p>
              This study identifies a shared genetic pathway between low stress
              resilience, magnesium deficiency, and depression. Individuals with
              these genetic traits may experience poor response to conventional
              antidepressants, suggesting that magnesium optimization and
              genetically based interventions could significantly enhance mental
              health outcomes. These results underscore the importance of
              personalized genetic profiling in understanding and managing
              depression, rather than relying solely on one-size-fits-all
              treatments.
            </p>
            <h3 className="op0_8"> Conclusion:</h3>
            <p>
              Magnesium deficiency isn’t just nutritional; for many, it’s
              genetic. Personalized lifestyle and supplementation strategies
              guided by genetic analysis can dramatically improve diabetes
              prevention and management outcomes.
            </p>
            <h3 className="op0_8"> Overall Implications</h3>
            <p>
              Across all three studies, the findings consistently point toward
              one message: Genetics profoundly influence how our bodies handle
              stress, mood, metabolism, and weight.
            </p>
            By decoding these genetic patterns through EPLIMO, individuals can:
            <ul className="mb-4 dot_list">
              <li>Identify hidden risks for depression, diabetes, and obesity
                early.</li>
              <li>
                Take proactive steps through customized nutrition,
                supplementation, and lifestyle changes.{" "}
              </li>
              <li>
                Improve treatment outcomes by aligning interventions with their
                unique genetic blueprint.{" "}
              </li>
            </ul>
            <h3 className="op0_8">Conclusion: </h3>
            <p>
              This series of studies establishes magnesium deficiency, stress
              resilience, and hormonal regulation as key genetic factors linking
              mental and metabolic health. Through EPLIMO’s personalized
              approach, these insights can be transformed into targeted action
              plans for improving long-term wellness and disease prevention.
            </p>
            <div className="pt-4 text-center">
              <a href="study-reveals" className="back_btn bn_btn"><i className="bi bi-chevron-left"></i></a>
              <a href="genetic-research" className="next_btn bn_btn"><i className="bi bi-chevron-right"></i></a>
            </div>
          </div>
        </section>
        <section className="you_ready_sec text-white position-relative  overflow-hidden">
          <img
            src="/assets/img/research/research_r_bg.webp"
            alt="cour raddy"
            className="cour_raddy mo_none"
          />
          <img
            src="/assets/img/research/research_r_bg2.webp"
            alt="cour raddy"
            className="cour_raddy pc_none"
          />

          <div className="container position-relative">
            <div className="row position-relative">
              <div className="col-md-5  ms-auto">
                <h2 className="hadding mb-4    ">
                  Are You Ready to Take Control of Your Future Health?
                </h2>
                <p className=" mb-md-4 mb-3 ">
                  EPLIMO is more than a health check. It’s a blueprint for
                  living stronger, longer, and happier. Don’t wait for symptoms
                  to become problems. Take charge today and start living at your
                  peak.
                </p>
                <a className="btn" onClick={() => openIframeWindow()}>
                  Join EPLIMO<sup className="sup-font">TM</sup> Program
                </a>
              </div>
            </div>
            <FormModal show={show} setShow={setShow} />
          </div>
        </section>
        <Footer />{" "}
      </section>
    </>
  );
}

export default GeneticRisk;
